export const DEBOUNCE_DELAY = 300;
export const DEBOUNCE_SEARCH_DELAY = 1200;

export const ONE_SECOND_IN_MS = 1000;

// Chat Sidebar Constants
export const CHAT_SIDEBAR_WIDTH = "20rem"; // w-80 = 320px
export const CHAT_SIDEBAR_MOBILE_MAX_WIDTH = "90vw";
export const CHAT_SIDEBAR_MAX_HEIGHT = "calc(100vh - 8rem)";

// Animation Durations
export const ANIMATION_DURATION_FAST = 300;
export const ANIMATION_DURATION_SLOW = 500;

export const VALUE_ALL = "all";

export const VALUE_LOW = "low";
export const VALUE_MEDIUM = "medium";
export const VALUE_HIGH = "high";
